import React, { useState } from "react";
import emailjs from "emailjs-com";

function Contact() {
  // Step 4: Define state variables to handle form input
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  // Step 5: Define a handleChange function to update state on input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Step 6: Define the function to handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      'service_jfifojn',      // Replace with your service ID
      'template_6bqv9lw',      // Replace with your template ID
      formData,                // Data to send
      'IyVGLXVSPPOZ4UEYm'           // Replace with your user ID
    )
    .then((result) => {
      alert("Message sent successfully!"); // Success message
      setFormData({ name: "", email: "", subject: "", message: "" }); // Clear form
    })
    .catch((error) => {
      alert("Failed to send message, please try again."); // Error message
    });
  };

  return (
    <div className="container contact">
      <h2 className="main-title text-center">Contact Us</h2>
      <form onSubmit={handleSubmit} className="col-md-12">
        <input
          name="name"
          placeholder="Your Name"
          className="contact-input"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          name="email"
          type="email"
          placeholder="Your Email"
          className="contact-input"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          name="subject"
          placeholder="Subject"
          className="contact-input"
          value={formData.subject}
          onChange={handleChange}
        />
        <textarea 
          name="message"
          placeholder="Your Message"
          className="contact-textarea"
          value={formData.message}
          onChange={handleChange}
          required
        />
        <div className="contact-button"> 
          <button
            type="submit"
            className="btn"
            style={{ cursor: "pointer", transition: "all 0.3s ease" }}
          >
            Send
          </button>
        </div>
      </form>
    </div>
  );
}

export default Contact;
